import { useState, useRef, useEffect } from "react";

const Section = ({
  id,
  title,
  children,
  spaceY4Needed = true,
  openByDefault = false,
}) => {
  return (
    <section id={id}>
      <div className="max-w-7xl mx-auto px-0 overflow-hidden">
        <div
          className={`w-full flex items-center justify-between px-4 font-semibold text-theme-color
          `}
        >
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-semibold mb-2 text-theme-color">{title}</h2>
          </div>
        </div>

        <div
          className="transition-all duration-700 ease-in-out overflow-hidden bg-white"
        >
          <div className={`p-6 ${spaceY4Needed ? "space-y-4" : ""}`}>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section;
